import { engineComponent } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { BaseView } from "../Base/BaseView";
import { ModuleManager } from "../../Managers/ModuleManager";
import { MinigameElement } from "../../CustomComponents/MinigameElement";
import { GameManager } from "../../Managers/GameManager";

export interface MinigameValue {
    type?: string;
    value?: number;
}

@engineComponent(ComponentTypes.DisplayObject)
export class FreespinsView extends BaseView {
    constructor() {
        super();
    }

    create(node: Element): void {
        super.create(node);

        if (this._minigame) {
            this._minigame.on(MinigameElement.EventButtonAction, this.configuratorAction.bind(this));
            this._minigame.on(MinigameElement.EventOutroFinished, this.minigameOutroFinished.bind(this));
        }
    }

    startConfigurator(): void {
        if (
            ModuleManager.freespinsEnabled() &&
            GameManager.freespinsResponse.customData &&
            Array.isArray(GameManager.freespinsResponse.customData.minigame)
        ) {
            if (this._minigame) {
                //this.toggleElements(false, false);
                this._minigame.intro(this.parseMinigameData(GameManager.freespinsResponse.customData.minigame));
            }
        }
    }

    private configuratorAction(index: number): void {
        this._controller.start(index);
    }

    private parseMinigameData(dataIn: Array<MinigameValue>): Array<number> {
        // parsing: first 2 objects are total score (fs/multipliers), then 9 fs scores, then 9 multiplier scores
        if (dataIn) {
            let minigameData: Array<number> = [];
            for (let i = 0; i < 18; i++) {
                minigameData.push(null);
            }
            let totalFS = 0;
            let totalMul = 1;
            dataIn.forEach((vObject, index) => {
                if (vObject && vObject.value !== null) {
                    if (vObject.type == "multiplier") {
                        minigameData[index + 9] = vObject.value;
                        totalMul += vObject.value;
                    } else {
                        minigameData[index] = vObject.value;
                        totalFS += vObject.value;
                    }
                }
            });
            minigameData.push(totalFS, totalMul);
            return minigameData;
        } else {
            return null;
        }
    }

    intro(): void {
        //this.toggleElements(true, true);
    }

    startReceived(): boolean {
        if (this._minigame) {
            if (
                GameManager.freespinsResponse.customData &&
                Array.isArray(GameManager.freespinsResponse.customData.minigame)
            ) {
                this._minigame.setData(this.parseMinigameData(GameManager.freespinsResponse.customData.minigame));
                if (ModuleManager.freespinsActive()) {
                    this._minigame.disable();
                    this._minigame.outro([
                        GameManager.freespinsResponse.freeSpins.totalCount,
                        GameManager.freespinsResponse.freeSpins.multiplier,
                    ]);
                    return true;
                }
            }
        }
        return false;
    }

    minigameOutroFinished(): void {
        ModuleManager.introModule(Communication.Game.GameModules.Freespins);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Freespins/FreespinsView.ts
 **/